<template>
  <li class="timeline-item">
    <div class="line-content-box">
      <p class="title mb-1">{{ question.title }}</p>
      <div>
        <Emoji @set-point="setQuestionValue" :checked="formData.note" :key="'emoji' +index" :base="'emoji' +index" v-if="question.type == 'NOTE'"/>
        <div v-else class="input-group mb-3 input-radius">
          <textarea v-model="form.note" class="form-control" placeholder="Textarea" rows="2"></textarea>
        </div>
      </div>
    </div>
    <div class="line-num">{{ index + 1 }}</div>
  </li>

</template>

<script setup>

import {onMounted, ref} from "vue";
import Emoji from "@/components/emoji";

// eslint-disable-next-line no-undef
const props = defineProps({
  question: {
    type: Object,
  },
  index:{
    type: Number,
    default: 1
  },
  formData: {
    type: Object,
  }

})

const form = ref(props.formData)

onMounted(() => {
})

function setQuestionValue(value){
  form.value.note = value
}
</script>

<style scoped>
.title{
  font-weight: 400;
}
.input-radius{
  border-radius: 10px;
}
</style>